import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

type EntryLimitReachedModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  maxNumEntriesPerUser: number;
  userNumEntries: number;
  resetAllEntryStore: () => void;
};
export const EntryLimitReachedModal = ({
  open,
  setOpen,
  maxNumEntriesPerUser,
  userNumEntries,
  resetAllEntryStore,
}: EntryLimitReachedModalProps) => {
  const navigate = useNavigate();

  const handleClickButton = () => {
    resetAllEntryStore();
    navigate("/");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] rounded-md">
        <DialogTitle className="text-black text-center text-xl mx-auto">エントリー数が上限に達しました。</DialogTitle>

        <div className="flex justify-center items-center mx-auto bg-gray rounded-full w-fit px-7 py-[9px] font-bold leading-[35px] text-dark-gray mt-1">
          <span>エントリー回数：</span>
          <span className="text-red">{userNumEntries}</span>
          <span>/{maxNumEntriesPerUser}</span>
        </div>

        <div className="flex flex-col w-full items-center justify-center mt-4">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={handleClickButton}
          >
            ホームへ
          </Button>
          <Button className="text-base mt-3" variant="link" onClick={handleClickButton}>
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
